import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function SuperSupport() {
  const [tickets, setTickets] = useState([]);
  const load = () => api.get("/super/support").then((r) => setTickets(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (t, status) => {
    await api.put(`/super/support/${t.id}`, { status });
    toast.success("Updated"); load();
  };

  return (
    <div data-testid="super-support">
      <div className="admin-overline">Inbox</div>
      <h1 className="admin-heading text-3xl font-bold mt-1 mb-6">Support tickets</h1>
      {tickets.length === 0 && (
        <div className="bg-white border border-neutral-200 p-12 text-center text-sm text-neutral-500">
          No tickets yet.
        </div>
      )}
      <div className="space-y-3">
        {tickets.map((t) => (
          <div key={t.id} className="bg-white border border-neutral-200 p-4 sm:p-5" data-testid={`super-ticket-${t.id}`}>
            <div className="flex flex-wrap justify-between items-start gap-3">
              <div className="min-w-0">
                <div className="font-semibold break-words">{t.subject}</div>
                <div className="text-xs text-neutral-500 mt-0.5 break-anywhere">Tenant: {t.tenant_slug} · Priority: {t.priority}</div>
              </div>
              <select value={t.status} onChange={(e) => setStatus(t, e.target.value)} className="border border-neutral-300 px-2 py-2 text-xs bg-white">
                {["open","in_progress","resolved","closed"].map((s) => <option key={s}>{s}</option>)}
              </select>
            </div>
            <p className="text-sm text-neutral-700 mt-3 leading-relaxed break-words">{t.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
